import { useCurrentUser } from "@indietabletop/appkit";
import { createContext, useContext } from "react";
import { useInvokeClient } from "../../client.ts";

export type CheckAccessResult = ReturnType<typeof useCheckAccess>[0];

export const AccessContext = createContext<ReturnType<
  typeof useCheckAccess
> | null>(null);

/**
 * Gets the result of a access check from context.
 *
 * Note that this hook doesn't make any requests -- it only gets data from
 * context.
 *
 * To perform requests, use either {@link useCheckAccess} or {@link CheckAccessProvider}.
 */
export function useCheckAccessResult() {
  const result = useContext(AccessContext);

  if (!result) {
    throw new Error(`Check access result not found in context.`);
  }

  return result;
}

/**
 * Checks with the API to see which unlocks this user has access to.
 */
export function useCheckAccess(props?: {
  /**
   * Explicitly opt into fetching.
   *
   * If not provided, will check only if current user is found in store.
   */
  performFetch?: boolean;
}) {
  const currentUser = useCurrentUser();
  const performFetch = props?.performFetch ?? !!currentUser;
  return useInvokeClient("getSpaceGitsUnlocks", [], { performFetch });
}
